import { Popover, styled } from '@mui/material';

export const StyledNotificationsPopover = styled(Popover)(({ theme }) => ({
	'& .MuiPopover-paper': {
		padding: '24px',
		borderRadius: '20px',
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		width: 'min(575px, calc(100% - 16px))',
		marginTop: '16px',
		background: theme.palette.modal.modalGradient,
		border: '3px solid transparent',
		maxWidth: 'unset',
		maxHeight: 'calc(100% - 112px)',

		'&::-webkit-scrollbar': {
			width: '4px',
		},
		'&::-webkit-scrollbar-track': {
			boxShadow: 'inset 0 0 6px rgba(0,0,0,0.1)',
			borderRadius: '10px',
			display: 'block',
			marginBlock: '10px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#888',
			borderRadius: '10px',
		},
		'&::-webkit-scrollbar-thumb:hover': {
			backgroundColor: '#555',
		},

		[theme.breakpoints.down('xs')]: {
			padding: '16px 8px 16px 8px',
			gap: '8px',
			margin: '24px 0px 0px 0px',
			left: '0px !important',
			right: '0px !important',
			marginInline: 'auto',
		},
	},
}));

export const StyledCustomPopoverHeaderWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});
